import { of as observableOf, Observable } from 'rxjs';

import { filter, switchMap, map, tap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { LoopBackAuth, MemberApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { CAAction, HydrateAuth } from '../actions';
import * as actions from '../actions/index';
import { Router, ActivatedRoute, ResolveStart } from '@angular/router';

const STORAGE_ACTION = '[Storage] Value changed';

@Injectable()
export class AuthEffects {
  @Effect()
  getAuthLogin = this.actions$.ofType(actions.REQUEST_AUTH_LOGIN).pipe(
    switchMap((action: actions.RequestAuthLoginAction) =>
      this.api
        .customLogin(action.payload)
        .map(res => new actions.ResponseSuccessAuthLoginAction(res))
        .catch(err => observableOf(new actions.ResponseFailAuthLoginAction(err)))
    )
  );

  @Effect()
  logoutIfNoOrganisations = this.actions$
    .ofType(actions.Organisations.NO_VALID_ORGANISATIONS)
    .pipe(map(action => new actions.RequestAuthLogoutAction()));

  @Effect({ dispatch: false })
  redirectAfterReset = this.actions$.ofType(actions.RESPONSE_SUCCESS_AUTH_FORGOT_PASSWORD).pipe(
    tap(() => {
      this.router.navigate(['/']);
    })
  );

  @Effect()
  getAuthLogout = this.actions$.ofType(actions.REQUEST_AUTH_LOGOUT).pipe(
    switchMap((action: any) => {
      return this.api
        .logout()
        .map(res => new actions.ResponseSuccessAuthLogoutAction())
        .catch(err => observableOf(new actions.ResponseSuccessAuthLogoutAction()));
    })
  );

  @Effect()
  getAuthForgotPassword = this.actions$.ofType(actions.REQUEST_AUTH_FORGOT_PASSWORD).pipe(
    switchMap((action: actions.RequestAuthForgotPasswordAction) => {
      return this.api
        .customResetPassword(action.payload)
        .map(res => new actions.ResponseSuccessAuthForgotPasswordAction())
        .catch(err => observableOf(new actions.ResponseFailAuthForgotPasswordAction(err)));
    })
  );

  @Effect()
  clearOnLogout = this.actions$
    .ofType(actions.RESPONSE_SUCCESS_AUTH_LOGOUT)
    .pipe(map(action => new actions.RequestStateReset()));

  @Effect()
  redirectOnLogout = this.actions$
    .ofType(actions.RESPONSE_SUCCESS_AUTH_LOGOUT)
    .pipe(map(() => actions.NavigateAction({ path: ['/auth'] })));

  @Effect()
  forceLogout = this.actions$
    .ofType(actions.FORCE_LOGOUT_401)
    .pipe(map(action => new actions.RequestAuthLogoutAction()));

  @Effect({ dispatch: false })
  tabTokenChanges = this.actions$.ofType(STORAGE_ACTION).pipe(
    filter(action => action.payload.key === 'auth'),
    tap(action => this.auth.setToken(action.payload.newValue.auth))
  );

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private api: MemberApi,
    private auth: LoopBackAuth,
    private router: Router
  ) {
    window.addEventListener('storage', event => {
      let newValue: any, key: string;
      ({ key, newValue } = event);
      try {
        newValue = JSON.parse(newValue);
      } catch (ex) {
        newValue = {};
      }
      this.store.dispatch({ type: STORAGE_ACTION, payload: { key, newValue } });
    });
  }
}
